import { FormikHelpers } from "formik";
import { useMemo } from "react";
import WheelPicker from "../picker/enlarge-picker";
import InputErrorsComponent from "./input-errors";

export type Option<T> = {
  label: string;
  value: T;
};

export type OptionPickerProps<Values, T> = {
  name: string;
  values: Record<string, string>;
  options: Option<T>[];
  setFieldValue: FormikHelpers<Values>["setFieldValue"];
  validateField?: FormikHelpers<Values>["validateField"];
  className?: string;
};

export const OptionPicker = <Values, T>({
  name,
  values,
  options,
  setFieldValue,
  validateField,
  className,
}: OptionPickerProps<Values, T>) => {
  const selectedOption = useMemo(
    () =>
      options.find((opt) => opt.value?.toString() === values[name]?.toString()),
    [options, values, name],
  );
  return (
    <>
      <WheelPicker
        options={options}
        value={selectedOption}
        labelBuilder={(opt) => opt.label}
        onChange={(selected) => {
          setFieldValue(name, selected.value);
          validateField?.(name);
        }}
        className={className}
      />
      <InputErrorsComponent inputName={name} />
    </>
  );
};
